<template>

	<v-toolbar class="white elevation-0 toolbar-edge">
		<!--<v-icon style="font-size: 47px;color: #0ec186 !important;text-shadow: rgba(190, 193, 192, 0.56) 2px 2px 6px"  @click="$router.replace({path: '/'})">polymer</v-icon>
		<h4 class="title pl-2 grey--text text--darken-1 font-weight-light">Lingo AV</h4>-->
		<router-link to="/">
		<img src="../../assets/lingoLogoGreen2.png" style="transform: scale(0.35);position: relative;left: -38px;"/>
		</router-link>
            <div class="font-weight-light" style="color: rgb(38, 39, 39);font-size: 1.7rem;position: relative;left: -71px;top: -5px;">Lingo AV</div>
	</v-toolbar>

</template>

<style scoped>
	.toolbar-edge {
	-webkit-box-shadow: 11px 10px 30px -23px rgba(0,0,0,0.75) !important;
	-moz-box-shadow: 11px 10px 30px -23px rgba(0,0,0,0.75) !important;
	box-shadow: 11px 10px 30px -23px rgba(0,0,0,0.75) !important;
	}
</style>

<script>

	export default {
	name: "lingo_toolbar_light",
	data() {
	return {
	};
	}
	};
</script>
